<template>
  <div class="settings">
  </div>
</template>

<script>
import EventBus from "../bus";
import functions from '../mixins/functions';
export default {
  name: 'settings',
  mixins: [functions],
  data () {
    return {
    }
  },
  created: function (){
    this.resetBar();
  },
  mounted: function () {
    EventBus.$emit("checklogin")
    this.$store.state.heading = "Einstellungen"
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/pages/Settings.vue